import { render, staticRenderFns } from "./add_mouth_gpt_content_form.vue?vue&type=template&id=db48a942"
import script from "./add_mouth_gpt_content_form.vue?vue&type=script&lang=js"
export * from "./add_mouth_gpt_content_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports